module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"workflow":"Suivi de la demande","please_note_after_validation_you_will_no_longer_be_able_to_modify_the_survey_form":"Attention, après validation, vous ne pourrez plus modifier le formulaire d\u0027enquête","submit":"Sauvegarder","loading":"Chargement...","comment":"Commentaire"}}')
  delete Component.options._Ctor
}
